import { render } from "./PasswordReminderView.vue?vue&type=template&id=4ad3c120&ts=true"
import script from "./PasswordReminderView.vue?vue&type=script&lang=ts"
export * from "./PasswordReminderView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__